var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "id": "business",
            "title": "Business",
            "src": "/images/sub/subvisual-business.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('page-section', {
    staticClass: "page-section--first",
    attrs: {
      "id": "business-roadmap"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_vm._v(" Business Roadmap ")];
      },
      proxy: true
    }])
  }, [_c('v-img', {
    attrs: {
      "aspect-ratio": 1200 / 1046,
      "src": "/images/sub/business/roadmap-img-en.png",
      "data-aos": "fade"
    }
  })], 1), _c('page-section-image', {
    attrs: {
      "id": "business-solution",
      "imageSrc": "/images/sub/business/business-img.jpg"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("IReis’s self-developed crop growth solution")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('p', [_vm._v("We provide our own self-developed solution through continuous research on crops in order to realize sustainable agriculture.")]), _c('p', [_vm._v("Our solution promotes crops’ healthy growth and enables crop cultivation of constant quality and amount. ")])];
      },
      proxy: true
    }])
  }), _c('page-section-image', {
    attrs: {
      "id": "business-facility",
      "imageSrc": "/images/sub/business/business-img2.jpg",
      "reverse": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("IReis smart farm facilities that enhance agricultural productivity")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('p', [_vm._v("Our smart farm facilities enable various types of agriculture regardless of region.")]), _c('p', [_vm._v("With our own technology and products based on extensive experience and expertise, we install smart farm facilities that optimize the crop growth environment.")]), _c('p', [_vm._v("We contribute to a sustainable future by introducing eco-friendly production facilities.")])];
      },
      proxy: true
    }])
  }), _c('page-section-image', {
    attrs: {
      "id": "business-crop",
      "imageSrc": "/images/sub/business/business-img3.jpg"
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("Smart farm technology-intensive cultivation system")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('p', [_vm._v("You can cultivate healthy plants in an efficient way with our own self-developed products and technologies.")]), _c('p', [_vm._v("Our system helps plants grow optimally by monitoring the growth environment in real time and controlling environmental factors such as temperature, humidity, and root zone measurement.")])];
      },
      proxy: true
    }])
  }), _c('page-section-image', {
    staticClass: "page-section--last",
    attrs: {
      "id": "business-distribution",
      "imageSrc": "/images/sub/business/business-img4.jpg",
      "reverse": ""
    },
    scopedSlots: _vm._u([{
      key: "title",
      fn: function fn() {
        return [_c('h4', {
          staticClass: "tit tit--lg"
        }, [_vm._v("Distribution of fresher and healthier agricultural products")])];
      },
      proxy: true
    }, {
      key: "text",
      fn: function fn() {
        return [_c('p', [_vm._v("You can buy or enjoy fresh agricultural products cultivated in IReis-operated smart farms or cooperative farms at supermarkets, department stores, and franchise restaurants.")]), _c('p', [_vm._v("Agricultural products cultivated with IReis’s technology boast of excellent quality and freshness obtained through thorough quality management. Safe and healthy agricultural products are supplied to consumers.")])];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }